import { render, staticRenderFns } from "./general_information.form.vue?vue&type=template&id=56f5d494&"
import script from "./general_information.form.vue?vue&type=script&lang=js&"
export * from "./general_information.form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports